import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "primeng/button";;
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { ConfirmationService } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { MessagesModule } from "primeng/messages";
import { DropdownModule } from "primeng/dropdown";
import { InputSwitchModule } from "primeng/inputswitch";
import { UsuarioInserirComponent } from "./usuario-inserir.component";
import { UsuarioInserirRoutingModule } from "./usuario-inserir-routing.module";
import { InputMaskModule } from "primeng/inputmask";
import { PasswordModule } from 'primeng/password';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UsuarioInserirRoutingModule,
        ButtonModule,
        InputTextModule,
        TableModule,
        HttpClientModule,   
        DividerModule,
        MessagesModule,
        DropdownModule,
        InputSwitchModule,
        InputMaskModule,
        PasswordModule
    ],
    providers: [ConfirmationService],
    declarations: [UsuarioInserirComponent]
})
export class UsuarioInserirModule { }
